import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Profile } from './profile.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private defaultProfile: Profile = {
    currency: 'EUR',
  };

  readonly profile$: Observable<Profile | null>;
  readonly isProfileLoading$: Observable<boolean>;

  private readonly _profile$: BehaviorSubject<Profile | null> =
    new BehaviorSubject<Profile | null>(null);
  private readonly _isProfileLoading$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  get profile(): Profile {
    return this._profile$.getValue() || { ...this.defaultProfile };
  }

  constructor() {
    this.profile$ = this._profile$.asObservable();
    this.isProfileLoading$ = this._isProfileLoading$.asObservable();
  }

  getProfile(): void {
    this._isProfileLoading$.next(true);

    const profile: Profile = {
      currency: 'EUR',
    };

    this._profile$.next(profile);

    this._isProfileLoading$.next(false);
  }
}
